const stages = [
  { label: 'Strategy Rules', desc: 'Entry, exit, stop loss, position sizing' },
  { label: 'Historical Data', desc: 'OHLCV candles for the target market' },
  { label: 'Simulation Engine', desc: 'Bar-by-bar trade execution logic' },
  { label: 'Results', desc: 'Trade log, metrics, equity curve' },
];

export default function BacktestProcessMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> How a Backtest Flows</div>
      <div className="platform-mock-body">
        <div className="mock-steps">
          {stages.map((s, i) => (
            <span key={s.label} style={{ display: 'contents' }}>
              {i > 0 && <div className="mock-step-arrow">&rarr;</div>}
              <div className="mock-step">
                <div className="mock-step-num">{i + 1}</div>
                <div className="mock-step-label">{s.label}</div>
                <div className="mock-step-desc">{s.desc}</div>
              </div>
            </span>
          ))}
        </div>
      </div>
      <div className="platform-mock-caption">Every backtest follows this pipeline: rules + data + engine = results.</div>
    </div>
  );
}
